<div class="gtw-custom-snackbar-content">
  <span class="snackbar-message">{{ data.message }}</span>
  
  @if (data.closable !== false) {
<button 
   
    mat-icon-button 
    class="snackbar-close-btn" 
    (click)="closeSnackbar()"
    aria-label="Close">
    <i class="fa fa-times"></i>
  </button>
}
</div>
